import React, { useState } from 'react';
import styles from './Accordion.module.css';

export default function Accordion({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${styles.item} ${open ? styles.itemOpen : ''}`}>
      <button
        className={styles.header}
        onClick={() => setOpen(prev => !prev)}
        aria-expanded={open}
      >
        <span className={styles.question}>{question}</span>
        <span className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`} aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 6l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
      <div
        className={styles.bodyWrapper}
        style={{ maxHeight: open ? '600px' : '0' }}
        aria-hidden={!open}
      >
        <div className={styles.body}>
          <p className={styles.answer}>{answer}</p>
        </div>
      </div>
    </div>
  );
}
